import { render, staticRenderFns } from "./DossierEdit.vue?vue&type=template&id=e3505f96"
import script from "./DossierEdit.vue?vue&type=script&lang=ts"
export * from "./DossierEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3505f96')) {
      api.createRecord('e3505f96', component.options)
    } else {
      api.reload('e3505f96', component.options)
    }
    module.hot.accept("./DossierEdit.vue?vue&type=template&id=e3505f96", function () {
      api.rerender('e3505f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/DossierEdit.vue"
export default component.exports